import React from 'react';
import DailyDetailView from './DailyDetailView';
import DepthAnalyticsView from './DepthAnalyticsView';

/**
 * Renderiza el bloque DashboardDetailSection de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DashboardDetailSection({
  v
}) {
  return React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "backdropFilter": "blur(0.555556vh)",
      "padding": "1.111111vh 1.481481vh",
      "display": v.detDisp,
      "flexDirection": "column",
      "gap": "0.740741vh",
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "zIndex": "2",
      "overflow": "visible"
    }
  }, v.text("\n        "), React.createElement(DailyDetailView, {
    v
  }), v.text("\n        "), React.createElement(DepthAnalyticsView, {
    v
  }), v.text("\n      "));
}
